import z from "zod";

const groupCategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  count: z.number(),
});

type GroupCategory = z.infer<typeof groupCategorySchema>;

export { groupCategorySchema, type GroupCategory };
